import React, { useEffect } from 'react';
import Select from '../../../../common/Select';
import { SelectWrapper, TableContainer } from '../styled';
import { SUBTYPES_FBO } from '../../../../../config';
import { useDispatch } from 'react-redux';
import { fetchDeleteSubtypesFbo, fetchGetAdminSubtypesFbo } from '../../../../../actions/admin';
import { showModal } from '../../../../../actions/modal';
import { parseError } from '../../../../../helpers';
import { toast } from 'react-toastify';
const List = (props) => {
  const { values, options, option, setOptions, setOption, subtypes, handleSwitchMode } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    if (values?.subtypesFbo) {
      setOptions(values?.subtypesFbo?.map((el) => ({ value: el?.code, label: el?.name })));
    }
  }, [values?.subtypesFbo]);

  const handleRemoveItem = (item) => {
    dispatch(
      fetchDeleteSubtypesFbo({
        fbmCode: option,
        code: item?.code,
        name: item?.name,
      }),
    )
      .then(() => {
        toast.info('Элемент был успешно удален');
        dispatch(fetchGetAdminSubtypesFbo());
      })
      .catch((err) => {
        toast.error(parseError(err));
      });
  };

  const handleConfirmDeleteItem = (item) => {
    dispatch(
      showModal('ConfirmDelete', {
        body: item.title,
        image: item.imgUrl,
        handleConfirm: () => handleRemoveItem(item),
      }),
    );
  };

  return (
    <>
      <SelectWrapper>
        <div>
          <Select
            label="Тип"
            placeholder={'Выберите тип'}
            options={options}
            value={options.find((o) => o?.value === option) || null}
            onChange={(selected) => {
              if (selected) {
                setOption(selected.value);
              } else {
                setOption(null);
              }
            }}
          />
        </div>
      </SelectWrapper>
      {values && option && (
        <TableContainer>
          <div className="fixed-table-container">
            <div className="fixed-table-body">
              <table className="table table-centered">
                <thead className="thead-light">
                  <tr>
                    <th />
                    <th>Наименование</th>
                    <th>Код</th>
                    <th>ОСГ, %</th>
                  </tr>
                </thead>
                <tbody>
                  {subtypes &&
                    subtypes.map((item, index) => (
                      <tr key={item.code}>
                        <td style={{ minWidth: '45px', maxWidth: '45px' }}>
                          <section className="correction-data">
                            <div
                              style={{ display: 'flex', flexDirection: 'column', rowGap: '8px' }}
                            >
                              <i
                                className="fe-edit edit-icon action-icon"
                                onClick={() => handleSwitchMode(SUBTYPES_FBO.EDIT, item)}
                                title="Изменить"
                              />
                              <i
                                className="fe-trash edit-icon action-icon"
                                onClick={() => handleConfirmDeleteItem(item)}
                                title="Удалить"
                              />
                            </div>
                          </section>
                        </td>

                        <td style={{ minWidth: '180px', maxWidth: '180px' }}>
                          <div>{item.name ? item.name : ''}</div>
                          <div>{item.legalEntityName ? item.legalEntityName : ''}</div>
                        </td>
                        <td style={{ minWidth: '180px', maxWidth: '180px' }}>
                          {item.code ? item.code : ''}
                        </td>
                        <td style={{ minWidth: '180px', maxWidth: '180px' }}>
                          {item.osgRequirementPercent?.toString()
                            ? item.osgRequirementPercent
                            : ' - '}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </TableContainer>
      )}
    </>
  );
};
export default List;
